import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { auth } from "../../App/routes";
import Logo from "../../static/Logo.svg";
import API from "../../utils/API";
import Loading from "../../utils/components/Loading";
import timeStampToDateFormat from "../../utils/helpers/timestampToDateFormat";
import "./_formboxdetail.scss";

const FormboxDetail = ({ translate }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [currentFormBoxItem, setCurrentFormBoxItem] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    API.getData(`formbox/${id}`).then(({ data: res }) => {
      setCurrentFormBoxItem(res.data);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDateFormat = (dateString) => {
    return timeStampToDateFormat(dateString);
  };

  return (
    <div className="formbox-detail container bg-white p-5">
      <div className="row">
        <div className="col-12 d-flex flex-wrap align-items-center justify-content-between">
          <img
            height="64px"
            className="my-3"
            src={currentFormBoxItem?.sender?.company_logo || Logo}
            alt="logo"
          />
          <img height="64px" className="my-3" src={Logo} alt="logo" />
        </div>
      </div>
      <div className="row">
        <div className="col-12 border-top border-bottom border-2 py-3">
          <p>
            {" "}
            {currentFormBoxItem != null
              ? `${currentFormBoxItem?.form?.no} - ${currentFormBoxItem?.form?.name}`
              : null}
          </p>
        </div>
      </div>

      {isLoading ? (
        <Loading text={translate("loading")} />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-12 information-text">
              <div className="row justify-content-start p-2">
                <div className="col-3 p-1">
                  {" "}
                  {translate("formbox.headers.sender")}{" "}
                </div>
                <div className="col-9 p-1">
                  {currentFormBoxItem !== null
                    ? `${currentFormBoxItem?.sender?.name} ${
                        currentFormBoxItem?.sender?.company_name
                          ? `, ${currentFormBoxItem?.sender?.company_name}`
                          : ""
                      }`
                    : null}
                </div>
              </div>

              <div className="row justify-content-start p-2">
                <div className="col-3 p-1">
                  {translate("formbox.headers.receiver")}
                </div>
                <div className="col-9 p-1">
                  {currentFormBoxItem !== null
                    ? currentFormBoxItem?.receiver?.map((rec, index) => (
                        <div className="row mb-3" key={index}>
                          <div className="col-12">
                            {`${rec["name"]}, ${rec["company_name"]} `}
                          </div>
                        </div>
                      ))
                    : null}
                </div>
              </div>

              {currentFormBoxItem?.info?.length ? (
                <div className="row justify-content-start p-2">
                  <div className="col-3 p-1">CC</div>
                  <div className="col-9 p-1">
                    {currentFormBoxItem !== null
                      ? currentFormBoxItem?.info?.map((rec, index) => (
                          <div className="row mb-3" key={index}>
                            <div className="col-12">
                              {`${rec["name"]}, ${rec["company_name"]} `}
                            </div>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="row justify-content-start p-2">
                <div className="col-3 p-1">
                  {translate("formbox.headers.due-date")}
                </div>
                <div className="col-9 p-1">
                  {currentFormBoxItem?.created_at
                    ? handleDateFormat(currentFormBoxItem?.created_at)
                    : null}
                </div>
              </div>

              {currentFormBoxItem !== null &&
              currentFormBoxItem?.attachments?.length ? (
                <div className="row">
                  <div className="col-12 border-top border-2 mt-2 py-3">
                    <div className="row p-2">
                      <div className="col-12 p-1">
                        {translate("formbox.headers.attachments")}
                      </div>
                    </div>

                    {currentFormBoxItem?.attachments?.map(
                      (attachment, index) => (
                        <div className="row p-2 align-items-center" key={index}>
                          <div className="col-12 p-1">
                            <div className="attachment d-flex justify-content-start align-items-center">
                              {attachment.file_name}

                              <a
                                href={attachment.file_path}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={attachment.file_path}
                                  alt={`${attachment.file_name} Attachment`}
                                  className="attachment-image"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="row">
                <div className="col-12 border-top border-2 mt-2 py-3">
                  <div className="row p-2">
                    <div className="col-3 p-1">
                      {translate("formbox.headers.form-no")}
                    </div>
                    <div
                      className="col-9 text-orange cursor--pointer"
                      onClick={() =>
                        navigate(
                          auth.formDetails.link.replace(
                            ":id",
                            currentFormBoxItem?.form?.id
                          )
                        )
                      }
                    >
                      {currentFormBoxItem !== null
                        ? `${currentFormBoxItem?.form?.no}`
                        : null}
                    </div>
                  </div>
                  <div className="row p-2">
                    <div className="col-3 p-1">
                      {translate("formbox.headers.revision")}
                    </div>
                    <div className="col-9">
                      {" "}
                      {currentFormBoxItem !== null
                        ? `${currentFormBoxItem?.form?.revision}`
                        : null}
                    </div>
                  </div>
                  <div className="row p-2">
                    <div className="col-3 p-1">
                      {translate("formbox.headers.version")}
                    </div>
                    <div className="col-9">
                      {" "}
                      {currentFormBoxItem !== null
                        ? `${currentFormBoxItem?.form?.version}`
                        : null}
                    </div>
                  </div>
                  <div className="row p-2">
                    <div className="col-3 p-1">
                      {translate("formbox.headers.status")}
                    </div>
                    <div className="col-9">
                      {" "}
                      {currentFormBoxItem !== null
                        ? `${currentFormBoxItem?.form?.status}`
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormboxDetail;
